const DIRECTORY_LINK_URL_PROTOCOLS = new Set(['http:', 'https:', 'ftp:', 'file:']);

/** Absolute URL with an allowed scheme (http, https, ftp, file). */
const isUrl = (value: string): boolean => {
  try {
    const parsed = new URL(value);
    return DIRECTORY_LINK_URL_PROTOCOLS.has(parsed.protocol.toLowerCase());
  } catch {
    return false;
  }
};

/**
 * Windows path:
 * - drive letter: C:\folder or C:/folder
 * - UNC share: \\server\share\...
 */
const isWindowsPath = (value: string): boolean => {
  if (/^[a-zA-Z]:[\\/]/.test(value)) {
    return true;
  }

  // UNC: \\server\share (at least two path segments after leading \\)
  return /^\\\\[^<>:"/\\|?*\u0000-\u001F]+\\[^<>:"/\\|?*\u0000-\u001F]+/.test(value);
};

/** Absolute Linux / POSIX path (single leading slash, not a protocol-relative URL). */
const isLinuxPath = (value: string): boolean => /^\/(?!\/)/.test(value) && !/\0/.test(value);

/**
 * Empty values are valid here so Yup `.required()` can own the required message.
 * Non-empty values must be a URL, Windows path, or Linux path.
 */
export const isValidDirectoryLink = (value?: string | null): boolean => {
  if (value === null || value === undefined) {
    return true;
  }

  const trimmed = String(value).trim();
  if (!trimmed) {
    return true;
  }

  return isUrl(trimmed) || isWindowsPath(trimmed) || isLinuxPath(trimmed);
};

export const DIRECTORY_LINK_FORMAT_MESSAGE = 'Directory Link must be a URL, a Windows file path, or a Linux file path.';
